module.exports = __webpack_public_path__ + "static/media/pork Soupe.fb7a30a5.jpg";